export interface IBuildDocumentationResponse {
  records: IBuildDocumentation[];
  totalRecordCount: number;
}

export interface IBuildDocumentation {
  jobCode: string;
  neighborhoodDescription: string;
  lotNumber: string;
  planDescription: string;
  contractName: string;
  closingDate: string | null;
  formDate: string | null;
  buildId: number | string;
  buildStatus: string;
  neighborhoodId: number | string;
  hasTermiteLetter: boolean;
  hasCertificateOfOccupancy: boolean;
  isClosingDateLocked: boolean;
}

export interface IBuildDocumentationDetails {
  neighborhoodId?: number;
  neighborhoodDescription: string;
  lotNumber: number;
  sageJobId: number;
  addressDisplay: string;
  planDescription: string;
  contractName: string;
  contractEmail: string;
  contractPhone: string;
  closingDate: string;
  isClosingDateLocked: boolean;
  buildId: number;
  buildStatus: string;
  lenderId: string;
  lenderDisplay: string;
  financingType: string;
  totalPurchasePrice: number;
}

export interface IBuildDocument {
  buildDocumentId: number;
  name: string;
  downloadPath: string;
}
export interface IDocumentationTaskFile {
  id: number;
  name: string;
}

export interface IBuildDocumentTask {
  documentationTaskId: number;
  type: string;
  name: string;
  fileNames: string[];
  hasDocuments: boolean;
}

export enum DocumentTaskType {
  FileUpload = 'FileUpload',
  PictureUpload = 'PictureUpload',
  SprayFoamPhotoSetUpload = 'SprayFoamPhotoSetUpload',
  MultiFileUpload = 'MultiFileUpload',
  SiteCertificationUpload = 'SiteCertificationUpload',
  LandscapeFileUpload = 'LandscapeFileUpload'
}
